<template>
    <b-navbar fixed="top" toggleable="lg" type="dark" variant="rekka-blue">
        <b-navbar-toggle v-if="pageOptions.pageWithHeaderToggles" @click="toggleMobileSidebar" class="mr-4" target="" />
        <b-navbar-brand href="#"><b class="ml-3">REKKAPESU</b></b-navbar-brand>

        <b-navbar-toggle v-if="pageOptions.pageWithHeaderToggles" class="ml-auto" target="nav-collapse">
            <template v-slot:default>
                <b-icon icon="three-dots-vertical" />
            </template>
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav v-if="pageOptions.pageWithHeaderNavigation" class="ml-auto">
                <b-nav-item @click="logout">{{ $t('text_nav_logout') | toUpperCase }}</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import { mapState , mapActions } from 'vuex'
import PageOptions from '../config/PageOptions'

export default {
    name: 'Header',
    data() {
        return {
            pageOptions: PageOptions,
        }
    },
    filters: {
		toUpperCase(value) {
			value = value.toString();
			return value.toUpperCase();
		}
	},
    computed: {
        ...mapState('auth', ['user']),
	},
	methods: {
        ...mapActions('auth', ['logout']),
        toggleMobileSidebar() {
            PageOptions.pageWithMobileSidebar = !PageOptions.pageWithMobileSidebar;
        },
    }
}
</script>
